export const countUnreadNotifications = (notifications, userId) => {
    return notifications.reduce((count, notification) => {
        return count + (!notification.readBy.includes(userId) ? 1 : 0);
    }, 0);
};
